import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { HttpHelperService } from '@helpers/http-helper.service';
import { ReportDownloadHistoryI } from '@interfaces/report-download-history.interface';
import { ReportDownloadHistoryHttpService } from '@services/reports/report-download-history-http.service';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReportDownloadHistoryService {
  private slug_url = 'download-history';

  constructor(
    private reportDownloadHistoryHttp: ReportDownloadHistoryHttpService,
    private httpHelperService: HttpHelperService,
    private http: HttpClient
  ) {}

  public get fullUrl() {
    return environment.OMNISMART_API_ATTENDANCE_REPORTS + this.slug_url;
  }

  public getReportData<TypeFilter>(
    sortDirection = 'desc',
    pageIndex = 0,
    pageSize = 10,
    active = 'createdAt',
    filters: TypeFilter
  ): Observable<{ meta: { itemCount: number }; data: ReportDownloadHistoryI[] }> {
    let params = new HttpParams()
      .set('sort', sortDirection)
      .set('active', active)
      .set('limit', pageSize.toString())
      .set('skip', ((pageIndex - 1) * pageSize).toString());

    params = this.httpHelperService.setHttpParams(params, filters);

    return this.reportDownloadHistoryHttp.get(this.fullUrl, params);
  }

  async downloadReport(url): Promise<any> {
    if (!url) {
      throw new Error('Download URL is required');
    }

    return firstValueFrom(
      this.http.get(url, {
        responseType: 'blob' as 'json',
      })
    );
  }
}
